// A deliberately tiny Markdown reader for docs/TECH_GUIDE.md, which the Help
// page renders (D-LAUNCH1). It handles exactly what that doc uses — #/##/###
// headings, paragraphs, "- " lists with wrapped lines, **bold** and *italic* —
// so the bundle doesn't carry a Markdown library for one page.

export function parseGuide(md) {
  const blocks = [];
  let para = [];
  let list = null;
  const flushPara = () => {
    if (para.length) blocks.push({ type: 'p', text: para.join(' ') });
    para = [];
  };
  const flushList = () => {
    if (list) blocks.push({ type: 'ul', items: list });
    list = null;
  };

  for (const raw of String(md || '').split('\n')) {
    const line = raw.trimEnd();
    const heading = line.match(/^(#{1,3})\s+(.*)$/);
    if (heading) {
      flushPara();
      flushList();
      blocks.push({ type: `h${heading[1].length}`, text: heading[2].trim() });
      continue;
    }
    const item = line.match(/^\s*[-*]\s+(.*)$/);
    if (item) {
      flushPara();
      list = list || [];
      list.push(item[1].trim());
      continue;
    }
    if (!line.trim()) {
      flushPara();
      flushList();
      continue;
    }
    if (list) {
      list[list.length - 1] += ` ${line.trim()}`;
      continue;
    }
    para.push(line.trim());
  }
  flushPara();
  flushList();
  return blocks;
}

/** 'a **b** *c*' → [{text:'a '},{text:'b',bold:true},{text:' '},{text:'c',italic:true}] */
export function inlineSegments(text) {
  const out = [];
  const re = /\*\*([^*]+)\*\*|\*([^*\s][^*]*)\*/g;
  let last = 0;
  let m;
  while ((m = re.exec(text))) {
    if (m.index > last) out.push({ text: text.slice(last, m.index) });
    if (m[1] !== undefined) out.push({ text: m[1], bold: true });
    else out.push({ text: m[2], italic: true });
    last = m.index + m[0].length;
  }
  if (last < text.length) out.push({ text: text.slice(last) });
  return out;
}
